"use client";

import React, { useRef, useState } from "react";
import { useDialog } from "@/hooks/useDialog";
import PropTypes from "prop-types";
import AltchaGate from "@/components/Altcha/AltchaGate";
import { useSearchParams } from "next/navigation";

const Busqueda = ({ isLoading, onSearch, user = null }) => {
  const { show } = useDialog();
  const searchParams = useSearchParams();

  const [inputCedularuc, setInputCedularuc] = useState(
    searchParams.get("cedula") ?? user?.cedularuc ?? "",
  );
  const [captchaToken, setCaptchaToken] = useState(null);

  const altchaRef = useRef(null);

  //const cedularuc =

  const resetAltcha = () => {
    setCaptchaToken(null);
    altchaRef.current?.reset?.();
  };

  const handleSearch = () => {
    if (!inputCedularuc.trim()) {
      show({
        type: "warning",
        title: "",
        message: "Por favor, ingresa una Cédula/RUC para buscar",
      });
      return;
    }

    const currentCaptchaToken = user ? null : captchaToken;

    if (!user && !currentCaptchaToken) {
      show({
        type: "warning",
        title: "",
        message: "Por favor, completa la validación para continuar.",
      });
      return;
    }

    if (!user) {
      resetAltcha();
    }

    onSearch(inputCedularuc, currentCaptchaToken);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
      className="space-y-6 rounded-xl bg-white p-6 shadow-md"
    >
      <div>
        <label className="mb-2 block text-sm font-medium text-gray-700">
          Cédula / RUC
        </label>
        <div className="relative flex items-center rounded-lg border border-gray-300 bg-white px-3 py-2 focus-within:ring-2 focus-within:ring-blue-500">
          <svg
            className="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <g
              strokeLinejoin="round"
              strokeLinecap="round"
              strokeWidth="2.5"
              fill="none"
              stroke="currentColor"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" />
            </g>
          </svg>

          <input
            disabled={isLoading || Boolean(user)}
            type="number"
            value={inputCedularuc}
            onChange={(e) => setInputCedularuc(e.target.value)}
            required
            placeholder="Ingrese su cédula o RUC"
            className="ml-3 flex-1 border-none bg-transparent text-sm text-gray-800 placeholder-gray-400 outline-none"
          />
        </div>
      </div>

      {!user && (
        <div className="flex justify-center">
          {!isLoading && (
            <AltchaGate
              ref={altchaRef}
              className="flex justify-center"
              onToken={setCaptchaToken}
            />
          )}
        </div>
      )}

      <div className="flex justify-center">
        <button
          type="submit"
          disabled={user ? false : isLoading || !captchaToken}
          className="btn btn-primary rounded-lg px-4 py-2"
        >
          {isLoading && <span className="loading loading-spinner"></span>}
          Buscar
        </button>
      </div>
    </form>
  );
};

export default Busqueda;

Busqueda.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSearch: PropTypes.func.isRequired,
  user: PropTypes.object,
};
